import { createFileRoute } from "@tanstack/react-router";

import {
  DEFAULT_ORDER_LIST_SORTING,
  getInfiniteOrdersQueryOptions,
} from "../../../entities/order/list-query-options";
import { parseFilterSearchToRequestDto } from "../../../entities/order/lib";
import { ordersSearchParamsSchema } from "../../../pages/orders-page/types";

export const Route = createFileRoute("/_layout-main/orders/")({
  validateSearch: ordersSearchParamsSchema,
  loaderDeps: ({ search }) => search,
  loader: ({ context: { queryClient }, deps: search }) =>
    queryClient.prefetchInfiniteQuery(
      getInfiniteOrdersQueryOptions({
        filter: parseFilterSearchToRequestDto(search),
        sorting: {
          columnName: search.sorting ?? DEFAULT_ORDER_LIST_SORTING.columnName,
          direction: search.sortingDir ?? DEFAULT_ORDER_LIST_SORTING.direction,
        },
      }),
    ),
});
